import { isUserMessage } from '@cascade/react/conversations';
import type {
  TChatMessageFile,
  TChatParticipantMessageProps,
} from '@cascade/ui-library';
import type {
  TConversationParticipants,
  TTranscriptFile,
  TTranscriptMessage,
} from './buildConversationMessage.types.ts';
import { AGENT_AVATAR_URL } from '#config/index.ts';

const PROCESSING_STATUS = 'processing';

export const buildChatFiles = (
  files?: TTranscriptFile[],
): TChatMessageFile[] | undefined =>
  files?.map((file) => ({
    id: file.file_id,
    filename: file.filename,
    src: file.signed_url,
    loading: file.status?.toLowerCase() === PROCESSING_STATUS,
  }));

export const buildConversationMessage = (
  message: TTranscriptMessage,
  { userName, agentName }: TConversationParticipants,
): TChatParticipantMessageProps => {
  const shared = {
    messageId: message.id,
    message: message.message ?? '',
    files: buildChatFiles(message.files),
  };

  return isUserMessage(message)
    ? { ...shared, name: userName, sender: 'active-user' }
    : {
        ...shared,
        name: agentName,
        sender: 'ai',
        avatarSrc: AGENT_AVATAR_URL,
        isMarkdown: true,
      };
};
